import React from 'react';
import './InfoSection.css'; // Import CSS for styling

const InfoSection = () => {
  return (
    <div className="split-section">
      <div className="left-side">
        <h2>Who Are We?</h2>
        <p className="text-box">SUBmerge Baltic is a Latvian startup working on dual use autonomous underwater drones (AUV) for water safety and security.</p>
      </div>
      <div className="right-side">
        <h2>How Are We Unique?</h2>
        <p className="text-box">We are using machine learning for navigation sensor data calibration to reduce drone price by 5 times and make it more accessible and convenient for large scale operations and kamikaze missions.</p>
      </div>
    </div>
  );
};

export default InfoSection;
